import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresProjetoService } from "../services/indicadores-projeto.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresSimplificadoProjetoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresProjetoListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdList(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresProjetoListEditResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresProjetoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}